var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 15.4963C32.5109 11.9701 30.8781 8.70289 28.3533 6.19788C25.8284 3.69288 22.5515 2.08905 19.0273 1.63347C15.5032 1.17789 11.9272 1.89582 8.8504 3.67667C5.77356 5.45753 3.3665 8.20251 2 11.4888M1 3.4738V11.4888H9M1 19.5037C1.48912 23.0299 3.12186 26.2971 5.64672 28.8021C8.17158 31.3071 11.4485 32.9109 14.9727 33.3665C18.4968 33.8221 22.0728 33.1042 25.1496 31.3233C28.2264 29.5425 30.6335 26.7975 32 23.5112M33 31.5262V23.5112H25",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.f982e491f1ec6d5f158669eebbed3046.svg";
export { ForwardRef as ReactComponent };